function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router';
import React from 'react';
import LogoText from '../LogoText';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { faDiscord, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { ActionIcon, Anchor, Container, Divider, Text, Title } from '@mantine/core';
import styles from './Footer.module.scss';
import classNames from 'classnames';
import Icon, { IconSizes } from '../Icon';
function LandingFooter(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.footerContainer, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "xl",
            className: styles.footer,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.footerLinkStack,
                    children: /*#__PURE__*/ _jsx(LogoText, {
                        color: "textPrimary"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.footerLinkStack,
                    children: [
                        /*#__PURE__*/ _jsx(Title, {
                            size: "sm",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "hzSNj4",
                                defaultMessage: "Dashboard"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            component: Link,
                            to: WebRoutes.DASHBOARD,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "ejEGdx",
                                defaultMessage: "Home"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            component: Link,
                            to: WebRoutes.COMMANDS,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "TY8Ho1",
                                defaultMessage: "Commands"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            component: Link,
                            to: WebRoutes.TIMERS,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "q5NYii",
                                defaultMessage: "Timers"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.footerLinkStack,
                    children: [
                        /*#__PURE__*/ _jsx(Title, {
                            size: "sm",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "HqRNN8",
                                defaultMessage: "Support"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            href: ExternalUrls.COMMUNITY_FORUM,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "XxAinn",
                                defaultMessage: "Community Forum"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            href: ExternalUrls.DISCORD,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "FvmV6q",
                                defaultMessage: "Discord"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            href: ExternalUrls.API_DOCS,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "yKOyCk",
                                defaultMessage: "API Documentation"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.footerLinkStack,
                    children: [
                        /*#__PURE__*/ _jsx(Title, {
                            size: "sm",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "7oFrM6",
                                defaultMessage: "Legal"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            component: Link,
                            to: WebRoutes.TERMS,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "32rBNK",
                                defaultMessage: "Terms of Service"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Anchor, {
                            component: Link,
                            to: WebRoutes.PRIVACY,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "vx0nkZ",
                                defaultMessage: "Privacy Policy"
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
function SocialFooter(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var intl = useIntl();
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.socialFooterContainer, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "xl",
            className: styles.footer,
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    c: "dimmed",
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "Cs32ER",
                        defaultMessage: "Copyright \xa9 {year} NightDev, LLC. All Rights Reserved",
                        values: {
                            year: new Date().getFullYear()
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.footerLinks,
                    children: [
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            "aria-label": intl.formatMessage({
                                id: "es45bQ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Join our Discord"
                                    }
                                ]
                            }),
                            variant: "transparent",
                            component: "a",
                            href: ExternalUrls.DISCORD,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                icon: faDiscord,
                                size: IconSizes.MD
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            "aria-label": intl.formatMessage({
                                id: "8itImv",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Follow us on X"
                                    }
                                ]
                            }),
                            variant: "transparent",
                            component: "a",
                            href: ExternalUrls.X,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                icon: faXTwitter,
                                size: IconSizes.MD
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionIcon, {
                            "aria-label": intl.formatMessage({
                                id: "eObXfZ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Subscribe to us on YouTube"
                                    }
                                ]
                            }),
                            variant: "transparent",
                            component: "a",
                            href: ExternalUrls.YOUTUBE,
                            children: /*#__PURE__*/ _jsx(Icon, {
                                icon: faYoutube,
                                size: IconSizes.MD
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
export default function Footer(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: classNames(styles.landingFooter, className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(LandingFooter, {}),
            /*#__PURE__*/ _jsx(Divider, {
                className: styles.divider
            }),
            /*#__PURE__*/ _jsx(SocialFooter, {})
        ]
    }));
}
